<!--
 * @Author: chenxing
 * @Date: 2021-04-07 20:00:21
 * @LastEditors: chenxing
 * @LastEditTime: 2021-05-27 16:27:50
-->
<template>
  <a-result status="403" title="403" sub-title="无权访问该页面">
    <template #extra>
      <a-button type="primary" @click="toHome">
        回到首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'Exception403',
  methods: {
    toHome () {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
